export default __webpack_public_path__ + "static/media/mode-560.b01c1c15.svg";